var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"roles-select"},_vm._l((_vm.roles),function(role){return _c('li',{key:role.value},[_c('label',[_c('u-checkbox',{attrs:{"val":role.value},model:{value:(_vm.user.roles),callback:function ($$v) {_vm.$set(_vm.user, "roles", $$v)},expression:"user.roles"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(role.label))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }